import { useState, useEffect } from 'react';
import baseURL from './url';

export default function useAuthUser() {
    const [usuario, setUsuario] = useState(() => {
        try {
            const cached = localStorage.getItem('usuario');
            return cached ? JSON.parse(cached) : {};
        } catch (e) {
            return {};
        }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const fetchUser = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include',
                });
                if (response.ok) {
                    const data = await response.json();
                    if (isMounted) {
                        setUsuario(data);
                        try {
                            localStorage.setItem('usuario', JSON.stringify(data));
                        } catch (e) {}
                    }
                } else {
                    if (isMounted) {
                        setUsuario({});
                        try {
                            localStorage.removeItem('usuario');
                        } catch (e) {}
                    }
                }
            } catch (err) {
                console.error("Error al obtener usuario:", err);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchUser();

        return () => {
            isMounted = false;
        };
    }, []);

    const isAdmin = Boolean(usuario && usuario.rol === 'admin');
    const isUsuario = Boolean(usuario && usuario.rol === 'usuario');

    return { usuario, loading, isAdmin, isUsuario };
}
